/**
 * KPI strip on the vendors list (S14a) — composes the shared `<StatTile>`.
 *
 * 4 tiles, mirroring `prototype/purchases/vendors.html ▸ .kpis`:
 *   - Total vendors      (real)
 *   - New this month     (real — last 30d)
 *   - Avg payment time   (placeholder — TODO V1.0.x with payments)
 *   - Top spend YTD      (placeholder — TODO V1.0.x with bills)
 *
 * Customers carries its own `kpi-strip.tsx` because the four signals
 * differ (Top exposure vs Top spend YTD, etc.) — the per-vertical files
 * own labels + tones; the tile shape is shared.
 */
import { Truck, TrendingUp, Timer, TriangleAlert } from "lucide-react";
import { StatTile } from "../../master-list/index.ts";

export interface KpiStripProps {
  total: number;
  archived: number;
  newThisMonth: number;
}

export function KpiStrip({ total, archived, newThisMonth }: KpiStripProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <StatTile
        label="Total vendors"
        value={total.toLocaleString("en-IN")}
        meta={archived > 0 ? `${archived.toLocaleString("en-IN")} archived` : "on file"}
        tone="sky"
        icon={Truck}
      />
      <StatTile
        label="New this month"
        value={newThisMonth.toLocaleString("en-IN")}
        meta="added in last 30d"
        tone="ok"
        icon={TrendingUp}
      />
      {/* TODO V1.0.x — avg(vendor_payments.paid_at − bills.received_on). */}
      <StatTile
        label="Avg payment time"
        value="—"
        meta="wires up with bills + payments"
        tone="warn"
        icon={Timer}
        placeholder
      />
      {/* TODO V1.0.x — MAX(SUM(paid_paise)) per vendor over the FY. */}
      <StatTile
        label="Top spend YTD"
        value="—"
        meta="wires up with bills"
        tone="bad"
        icon={TriangleAlert}
        placeholder
      />
    </div>
  );
}
